import Loader from "@/components/Loader/Loader";
import { getInvoicesSummary } from "@/services/api/interface-validator/invoices";
import { customCurrencyFormatter } from "@/utils/currencyFormatter";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { DialogTitle, ModalDialog, Typography } from "@mui/joy";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Table from "@mui/joy/Table";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { useState } from "react";

export default function InvoicesSummaryByDate() {
  const [isModalOpen, setModalOpen] = useState(false);

  const summaryQueryClient = useQuery({
    queryKey: ["invoicesSummary"],
    queryFn: getInvoicesSummary,
    enabled: isModalOpen,
  });

  return (
    <>
      <Button variant="plain" color="neutral" onClick={() => setModalOpen(true)}>
        <SummarizeOutlinedIcon
          sx={{
            fontSize: "20px",
          }}
          color="neutral"
        />
      </Button>

      <Modal open={isModalOpen} onClose={() => setModalOpen(false)}>
        <ModalDialog sx={{ width: "60vw", maxHeight: "80vh", overflowY: "auto" }}>
          <ModalClose />
          <DialogTitle>Invoices Summary By Date</DialogTitle>
          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>No. of IF Invoices</th>
                <th>Total IF Amount</th>
                <th>No. of AR Invoices </th>
                <th>Total AR Amount</th>
              </tr>
            </thead>
            <tbody>
              {summaryQueryClient.isLoading ? (
                <tr>
                  <td colSpan={5}>
                    <Loader />
                  </td>
                </tr>
              ) : (
                summaryQueryClient.data?.data.map((summary) => (
                  <tr key={summary.date}>
                    <td>
                      <Typography fontSize={"0.875rem"} fontWeight={500} textColor={"#334155"}>
                        {format(new Date(summary.date), "dd MMM, yyyy")}
                      </Typography>
                    </td>
                    <td>
                      <Typography fontSize={"0.875rem"} fontWeight={500} textColor={"#334155"}>
                        {summary.ifInvoice?.count || "-"}
                      </Typography>
                    </td>
                    <td>
                      <Typography fontSize={"0.875rem"} fontWeight={500} textColor={"#334155"} textAlign={'right'}>
                        {summary.ifInvoice?.totalAmount ? customCurrencyFormatter(summary.ifInvoice.totalAmount) : "-"}
                      </Typography>
                    </td>
                    <td>
                      <Typography fontSize={"0.875rem"} fontWeight={500} textColor={"#334155"}>
                        {summary.arInvoice?.count || "-"}
                      </Typography>
                    </td>
                    <td>
                      <Typography fontSize={"0.875rem"} fontWeight={500} textColor={"#334155"} textAlign={'right'}>
                        {summary.arInvoice?.totalAmount ? customCurrencyFormatter(summary.arInvoice.totalAmount) : "-"}
                      </Typography>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </ModalDialog>
      </Modal>
    </>
  );
}
